
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQ from './FAQ';
import GoogleTagManager from '../components/GoogleTagManager';


function Mumbaitobanglorecab() {



    const cardData =
    {
        keyword: ' Mumbai to Bangalore Cab',
        heading: 'Deva Cabs:  Mumbai to Bangalore Cab',
        headingDescription: 'Deva Cabs offers reliable, comfortable, and hassle-free cab services from Mumbai to Bangalore. Whether you are traveling for work, relocation, or a leisure trip, our experienced drivers and premium fleet ensure a smooth and safe long-distance journey. Bangalore, known as India’s Silicon Valley, is a bustling hub of technology, culture, and gardens. With door-to-door pickup, flexible travel options, and well-equipped vehicles for long drives, Deva Cabs guarantees a comfortable and stress-free ride from Mumbai to Bangalore every time.',

        top: 'Top Places to Visit in Tuljapur with Deva Cabs',

"topPlaces": [
  {
    "title": "Lalbagh Botanical Garden",
    "location": "Bangalore, Karnataka",
    "description": "Spread across 240 acres, Lalbagh is famed for its historic Glass House, centuries‑old flora, peninsular gneiss rock formations, and lively flower shows during Republic and Independence Days. A major draw for nature lovers, photographers, and families :contentReference[oaicite:2]{index=2}."
  },
  {
    "title": "Cubbon Park",
    "location": "Richmond Town, Bangalore, Karnataka",
    "description": "An urban oasis spanning 300 acres, featuring colonial-era libraries, toy trains, fish aquarium, dog park, and memorials—perfect for morning walks, bird-watching, leisure, and connecting with Bangalore’s heritage :contentReference[oaicite:3]{index=3}."
  },
  {
    "title": "Bangalore Palace",
    "location": "Vasanth Nagar, Bangalore, Karnataka",
    "description": "A Tudor-style royal residence built in 1887, with fortified towers, ornate wood-carvings, grand ballroom, and manicured lawns. Popular for cultural events, photo shoots, and history enthusiasts :contentReference[oaicite:4]{index=4}."
  },
  {
    "title": "Tipu Sultan’s Summer Palace",
    "location": "Old Bangalore, Karnataka",
    "description": "A stunning 18th-century Indo-Islamic teakwood palace within the old fort area. Known for its elaborate arches, balconies, and history as Tipu Sultan’s durbar venue :contentReference[oaicite:5]{index=5}."
  },
  {
    "title": "ISKCON Temple Bangalore",
    "location": "Rajajinagar, Bangalore, Karnataka",
    "description": "A majestic modern temple complex dedicated to Lord Krishna, known for its spacious halls, spiritual ambience, musical aartis, vegetarian cuisine, and educational programs—drawing devotees and visitors alike :contentReference[oaicite:6]{index=6}."
  },
  {
    "title": "Bannerghatta National Park",
    "location": "Bannerghatta, Bangalore Rural, Karnataka",
    "description": "A wildlife reserve ~35 km south of the city featuring a zoo, butterfly park, and safari tours for tigers, lions, and herbivores. Popular for day-trips with families and wildlife photographers :contentReference[oaicite:7]{index=7}."
  },
  {
    "title": "Wonderla Amusement Park",
    "location": "Mysore Road, Bangalore, Karnataka",
    "description": "India’s top water-and-thrill park with over 55 rides, musical fountains, VR shows, and eco-friendly pools. Recognized among Asia’s best amusement parks, it also hosts an adjoining resort :contentReference[oaicite:8]{index=8}."
  },
  {
    "title": "Market & Heritage Walks (KR Market, Commercial Street)",
    "location": "City Center, Bangalore, Karnataka",
    "description": "KR Market buzzes with flowers, spices, and local life since 1928. Nearby, Commercial Street offers vibrant shopping. Heritage neighbourhoods like Ulsoor, Pete, and Shivajinagar provide street-level culture and culinary immersion :contentReference[oaicite:9]{index=9}."
  },
  {
    "title": "National Gallery of Modern Art",
    "location": "Palace Road, Bangalore, Karnataka",
    "description": "Housed in a colonial-era mansion, this museum features Indian modern and contemporary art from the 18th century onward. Ideal for art lovers and cultural explorers :contentReference[oaicite:10]{index=10}."
  },
  {
    "title": "Nandi Hills",
    "location": "Chikkaballapur district, Karnataka (~60 km from Bangalore)",
    "description": "A serene hill station renowned for sunrise treks, misty panoramas, ancient fort ruins, and biking trails—perfect for weekend getaways and nature escapes :contentReference[oaicite:11]{index=11}."
  }
],



"services": [
    {
        "name": "Mumbai to Bangalore Cab",
        "description": "Reliable and comfortable cab service from Mumbai to Bangalore. Perfect for business trips, family travel, or leisure, with a range of vehicle options."
    },
    {
        "name": "Outstation Cab Mumbai to Bangalore",
        "description": "Safe and affordable outstation cab service from Mumbai to Bangalore, ensuring a hassle-free journey with experienced drivers."
    },
    {
        "name": "Long Distance Cab Mumbai to Bangalore",
        "description": "Travel long distances comfortably with our Mumbai to Bangalore cab service, featuring spacious vehicles and professional chauffeurs."
    },
    {
        "name": "One Way Mumbai to Bangalore Taxi",
        "description": "Convenient one-way taxi service from Mumbai to Bangalore, ideal for quick trips and flexible scheduling."
    },
    {
        "name": "Round Trip Cab Mumbai to Bangalore",
        "description": "Book a round trip cab from Mumbai to Bangalore with competitive pricing and reliable service for your travel needs."
    },
    {
        "name": "SUV Cab to Bangalore from Mumbai",
        "description": "Spacious and comfortable SUV cab rentals from Mumbai to Bangalore, perfect for families and groups with luggage."
    },
    {
        "name": "AC Cab Mumbai to Bangalore",
        "description": "Travel in comfort with our air-conditioned cab service from Mumbai to Bangalore, ensuring a pleasant journey."
    },
    {
        "name": "Luxury Cab Hire Mumbai to Bangalore",
        "description": "Experience premium travel with luxury cab hires from Mumbai to Bangalore, ideal for corporate and special occasions."
    },
    {
        "name": "Affordable Mumbai to Bangalore Taxi",
        "description": "Budget-friendly Mumbai to Bangalore taxi options without compromising on comfort and safety."
    },
    {
        "name": "Book Cab Online Mumbai to Bangalore",
        "description": "Easy online booking for your Mumbai to Bangalore cab with instant confirmation and a variety of vehicle options."
    },
    {
        "name": "Chauffeur-driven Cab to Bangalore",
        "description": "Professional chauffeur-driven cab service from Mumbai to Bangalore for a safe and convenient travel experience."
    },
    {
        "name": "Mumbai to Bangalore Premium Cab",
        "description": "Premium cab service from Mumbai to Bangalore offering top-notch vehicles and excellent customer service."
    },
    {
        "name": "Economy Cab Mumbai to Bangalore",
        "description": "Cost-effective economy cab options for Mumbai to Bangalore trips, suitable for solo travelers and small groups."
    },
    {
        "name": "Mumbai to Bangalore Tour Cab",
        "description": "Specialized tour cab service from Mumbai to Bangalore for sightseeing and customized travel itineraries."
    },
    {
        "name": "Family Cab Mumbai to Bangalore",
        "description": "Comfortable and spacious family cab services from Mumbai to Bangalore, ensuring a safe and pleasant journey."
    }
],

"tableData": [
    ["Mumbai to Bangalore Cab", "-Outstation Cab Mumbai to Bangalore"],
    ["Long Distance Cab Mumbai to Bangalore", "-One Way Mumbai to Bangalore Taxi"],
    ["Round Trip Cab Mumbai to Bangalore", "-SUV Cab to Bangalore from Mumbai"],
    ["AC Cab Mumbai to Bangalore", "-Luxury Cab Hire Mumbai to Bangalore"],
    ["Affordable Mumbai to Bangalore Taxi", "-Book Cab Online Mumbai to Bangalore"],
    ["Chauffeur-driven Cab to Bangalore", "-Mumbai to Bangalore Premium Cab"],
    ["Economy Cab Mumbai to Bangalore", "-Mumbai to Bangalore Tour Cab"],
    ["Family Cab Mumbai to Bangalore"]
],

whychoose: [
  {
    "WhyChooseheading": "Reliable and On-Time Pickup from Mumbai",
    "WhyChoosedescription": "Start your journey from Mumbai to Bangalore with confidence. Deva Cabs ensures timely pickups from your doorstep—so you can begin your long-distance travel without delay."
  },
  {
    "WhyChooseheading": "Comfortable and Clean Cabs for Long-Distance Travel",
    "WhyChoosedescription": "Enjoy a smooth and relaxing ride to Bangalore in our well-maintained, air-conditioned cars. With comfortable seating, extra legroom, and ample luggage space, long drives feel effortless."
  },
  {
    "WhyChooseheading": "Experienced Drivers for Intercity Routes",
    "WhyChoosedescription": "Our professional drivers are well-versed in the Mumbai to Bangalore route. They drive safely, take the best highways, and ensure you have a comfortable and efficient travel experience."
  },
  {
    "WhyChooseheading": "Transparent and Competitive Fare Structure",
    "WhyChoosedescription": "Deva Cabs offers upfront pricing with no hidden charges for Mumbai to Bangalore cab bookings. Know exactly what you’ll pay before your ride begins—no surprises along the way."
  },
  {
    "WhyChooseheading": "Available 24/7 for Mumbai to Bangalore Trips",
    "WhyChoosedescription": "Heading to Bangalore late at night or starting early in the morning? Our cab service is available 24/7, so you can travel whenever it suits you."
  },
  {
    "WhyChooseheading": "Safety and Hygiene Guaranteed",
    "WhyChoosedescription": "Your safety comes first. All vehicles are GPS-enabled, thoroughly sanitized, and driven by background-verified professionals who follow all safety protocols and traffic norms."
  },
  {
    "WhyChooseheading": "Seamless Booking with Real-Time Updates",
    "WhyChoosedescription": "Book your cab from Mumbai to Bangalore in seconds using our app or website. Enjoy instant confirmation, real-time driver tracking, and dedicated customer support."
  },
  {
    "WhyChooseheading": "Custom Travel Plans to Suit Your Journey",
    "WhyChoosedescription": "Whether it’s a one-way trip, round-trip, or multi-day business travel, Deva Cabs offers flexible packages tailored to your Mumbai to Bangalore travel needs."
  }
]






















    }




const faqData = [
  {
    question: "Can I book a cab from Mumbai to Bangalore with Deva Cabs?",
    answer: "Yes, Deva Cabs provides reliable and comfortable cab services from Mumbai to Bangalore. You can book your ride easily through our website, mobile app, or by contacting customer support."
  },
  {
    question: "What vehicle options are available for the Mumbai to Bangalore trip?",
    answer: "We offer a range of vehicle options including hatchbacks, sedans, SUVs, and premium cars to make your journey from Mumbai to Bangalore comfortable and enjoyable."
  },
  {
    question: "How long does the journey from Mumbai to Bangalore take?",
    answer: "The journey from Mumbai to Bangalore typically takes around 18 to 22 hours depending on traffic, road conditions, and your chosen route."
  },
  {
    question: "Can I book a one-way cab from Mumbai to Bangalore?",
    answer: "Yes, you can book a one-way cab from Mumbai to Bangalore. We offer one-way trips with no additional charges for one-way journeys."
  },
  {
    question: "What are the payment options for the Mumbai to Bangalore cab ride?",
    answer: "We accept a variety of payment methods, including cash, credit/debit cards, UPI, and online payments through our mobile app or website."
  },
  {
    question: "Can I pre-schedule my ride from Mumbai to Bangalore?",
    answer: "Yes, you can pre-schedule your ride for any date and time through our booking portal or mobile app to ensure a guaranteed pick-up."
  },
  {
    question: "Are the drivers experienced for Mumbai to Bangalore trips?",
    answer: "Yes, all our drivers are experienced, verified, and well-versed with the Mumbai to Bangalore route, ensuring a safe and smooth journey."
  },
  {
    question: "Is it safe to travel from Mumbai to Bangalore with Deva Cabs?",
    answer: "Absolutely! Our cabs are GPS-enabled, and all drivers undergo a thorough verification process. We prioritize safety and comfort for long-distance journeys."
  }
];

const testimonialData = [
  {
    id: 1,
    name: 'Mr. Akash Reddy',
    role: 'Business Traveler',
    review: 'I often travel from Mumbai to Bangalore for work, and Deva Cabs has been my go-to service. The drivers are professional, and the ride is always comfortable and punctual.',
    rating: 5,
    quoteIcon: '/img/icon/testi-quote.svg',
  },
  {
    id: 2,
    name: 'Ms. Shruti Singh',
    role: 'Tourist',
    review: 'I took a cab from Mumbai to Bangalore with Deva Cabs for a sightseeing trip. The entire experience was hassle-free, and the driver was very knowledgeable about places to visit along the way.',
    rating: 5,
    quoteIcon: '/img/icon/testi-quote.svg',
  }
];




























    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 8108807171",
            "+91 9764227171",



        ],
        email: "booking@devacab.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Cab Service in Mumbai",
            link: "/Cab-Service-in-Mumbai"
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Cab Service in Navi Mumbai",
            link: "/Cab-Service-in-Navi-Mumbai"
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Cab Service in Thane",
            link: "/Cab-Service-in-Thane"
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Cab Service Near Me Mumbai",
            link: "/Cab-Service-Near-Me-Mumbai"
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Car Rental in Mumbai",
            link: "/Car-Rental-in-Mumbai"
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Corporate Cab Services in Mumbai",
            link: "/Corporate-Cab-Services-in-Mumbai"
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Online Taxi Booking Mumbai",
            link: "/Online-Taxi-Booking-Mumbai"
        },
        {
            place: "/images/keyword/8.jpg",
            text: "Wedding Car Rental Mumbai",
            link: "/Wedding-Car-Rental-Mumbai"
        },
        {
            place: "/images/keyword/9.jpg",
            text: "Tempo Traveller on Rent in Mumbai",
            link: "/Tempo-Traveller-on-Rent-in-Mumbai"
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Innova Crysta on Rent in Mumbai",
            link: "/Innova-Crysta-on-Rent-in-Mumbai"
        },
        {
            place: "/images/keyword/11.jpg",
            text: "Ertiga on Rent in Mumbai",
            link: "/Ertiga-on-Rent-in-Mumbai"
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Mini Bus on Rent in Mumbai",
            link: "/Mini-Bus-on-Rent-in-Mumbai"
        },
        {
            place: "/images/keyword/13.jpg",
            text: "Mumbai Airport Cab Booking",
            link: "/Mumbai-Airport-Cab-Booking"
        },
        {
            place: "/images/keyword/14.jpg",
            text: "Navi Mumbai Car Rental Service",
            link: "/Navi-Mumbai-Car-Rental-Service"
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Mumbai Airport to Pune Cab",
            link: "/Mumbai-Airport-to-Pune-Cab"
        },
        {
            place: "/images/keyword/16.jpg",
            text: "Mumbai Airport to Shirdi Taxi",
            link: "/Mumbai-Airport-to-Shirdi-Taxi"
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Pune to Mumbai Airport Cab",
            link: "/Pune-to-Mumbai-Airport-Cab"
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Pune Airport to Mumbai Cab",
            link: "/Pune-Airport-to-Mumbai-Cab"
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Surat to Mumbai Airport Taxi",
            link: "/Surat-to-Mumbai-Airport-Taxi"
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Nashik to Mumbai Airport Cab",
            link: "/Nashik-to-Mumbai-Airport-Cab"
        },
        {
            place: "/images/keyword/21.jpg",
            text: "Mumbai to Nashik Cab",
            link: "/Mumbai-to-Nashik-Cab"
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Mumbai to Shirdi Cab",
            link: "/Mumbai-to-Shirdi-Cab"
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Mumbai to Lonavala Cab",
            link: "/Mumbai-to-Lonavala-Cab"
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Mumbai to Khandala Cab",
            link: "/Mumbai-to-Khandala-Cab"
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Mumbai to Lavasa Cab",
            link: "/Mumbai-to-Lavasa-Cab"
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Mumbai to Matheran Cab",
            link: "/Mumbai-to-Matheran-Cab"
        }
    ];



    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },

    ];




const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Bangalore Cab",
  "image": "https://devacab.com/assets/images/mumbai-to-bangalore-cab.jpg", // Replace with actual image URL
  "description": "Reliable and affordable Mumbai to Bangalore cab service by Deva Cabs. Book outstation taxis for one-way and round trips with luxury, economy, SUV, and AC options. Chauffeur-driven cabs available for family trips, corporate travel, and tours.",
  "brand": {
    "@type": "Brand",
    "name": "Deva Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "4200"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "8500", // Example price, adjust as needed
    "availability": "https://schema.org/InStock",
    "url": "https://devacab.com/mumbai-to-bangalore-cab" // Replace with actual page URL
  }
};





    return (
        <div>
<GoogleTagManager/>
<Helmet>
  <title>Mumbai to Bangalore Cab | Outstation Taxi Mumbai to Bangalore | Deva Cabs</title>
  <meta
    name="description"
    content="Book reliable Mumbai to Bangalore cab service with Deva Cabs. Affordable outstation taxis with luxury, economy, SUV, and AC options. Chauffeur-driven cabs for family trips, corporate travel, and tours."
  />
  <meta
    name="keywords"
    content="Mumbai to Bangalore Cab, Outstation cab Mumbai to Bangalore, Long distance cab Mumbai to Bangalore, One way Mumbai to Bangalore taxi, Round trip cab Mumbai to Bangalore, SUV cab to Bangalore from Mumbai, AC cab Mumbai to Bangalore, Luxury cab hire Mumbai to Bangalore, Affordable Mumbai to Bangalore taxi, Book cab online Mumbai to Bangalore, Chauffeur-driven cab to Bangalore, Mumbai to Bangalore premium cab, Economy cab Mumbai to Bangalore, Mumbai to Bangalore tour cab, Family cab Mumbai to Bangalore"
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



            <div className="breadcumb-wrapper" >
                <div className="container">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>



            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/66.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#F8911B', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                // padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    // padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className=''>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Deva Cabs</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQ faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword testimonialData={testimonialData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1" key={e.text}>
                                        <a
                                            href={e.link} // Use the separate link for each item
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt={e.text} />
                                            </div>
                                            <div className="b2">
                                                <a href={e.link} className="px-3 colorr">{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #562018',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#562018' }}>
                                            <h4 className=" lead fw-semibold whitt text-white bg-ora">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+91 8108807171" className="d-block  text-white">+91 8108807171</a>
                                                <a href="tel:+91 9764227171" className="d-block  text-white">+91 9764227171</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#562018' }}>
                                                <h4 className=" fw-semibold lead whitt text-white bg-ora">Email</h4>
                                                <a href="mailto:booking@devacab.com" className=" text-white d-block">
                                                    booking@devacab.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#562018' }}>
                                                <h4 className=" fw-semibold lead whitt text-white bg-ora">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Deva Cabs<br />
                                                        SS-2 404 Sector -17 Behind Mother India School Koparkhairne Navi Mumbai 400709
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </section>

        </div>
    );
}

export default Mumbaitobanglorecab;